export const Environment = {
  DateTimeMs: 3,
  PageSizeUpdate: 300,
  OneHourMs: 3600000,
  OneMounthMs: 2592000000,

  TableWidth: 1000000,
  TableHeight: 1000000,

  FieldWidth: 50,
  FieldHeight: 30,
};
